<div class="container-fluid">
  <section *ngIf="visitInfo$ | async as visitInfo"
    class="row distribute-sections py-3">
    <div class="  distribute-sections__column">
      <app-questions-resource-list
        [query]="{resourceName : customOptions?.resource?.resourceName , visitType :visitInfo.visitType }"
        (addQuestion)="addQuestion($event)"></app-questions-resource-list>
    </div>
    <app-questions-container class="d-flex flex-column distribute-sections__column"
      [opened]="sideOpened"
      (close)="closeQuestion()">

      <app-questions-list class="d-flex flex-column h-100"
        [visitInfo]="visitInfo"
        (edit)="editQuestion($event)"
        (delete)="deleteQuestion($event)"
        (open)="openQuestion($event)"></app-questions-list>

      <app-questions-container-side>
        <app-question-item [question]="selectedQuestion"></app-question-item>
      </app-questions-container-side>

    </app-questions-container>


  </section>

</div>
